/**
 * Re-render Judge.me preview badges after dynamic product lists load
 * (homepage featured, product recommendations AJAX, etc.).
 */
(function () {
  'use strict';

  function refreshPreviewBadges() {
    if (typeof window.jdgm === 'undefined') return;
    if (typeof window.jdgm.batchRender === 'function') {
      window.jdgm.batchRender();
      return;
    }
    if (typeof window.jdgm.renderBadges === 'function') {
      window.jdgm.renderBadges();
    }
  }

  function scheduleRefresh() {
    refreshPreviewBadges();
    window.setTimeout(refreshPreviewBadges, 400);
    window.setTimeout(refreshPreviewBadges, 1500);
  }

  window.esRefreshJudgemeBadges = scheduleRefresh;

  function observeDynamicProductLists() {
    if (!window.MutationObserver) return;

    document
      .querySelectorAll('.product-recommendations, [data-section-type="featured-collection"]')
      .forEach(function (root) {
        var observer = new MutationObserver(function () {
          scheduleRefresh();
        });
        observer.observe(root, { childList: true, subtree: true });
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scheduleRefresh();
      observeDynamicProductLists();
    });
  } else {
    scheduleRefresh();
    observeDynamicProductLists();
  }

  document.addEventListener('jdgm.doneLoadingCss', scheduleRefresh);

  function getHeaderOffset() {
    var root = document.documentElement;
    var header = parseInt(root.style.getPropertyValue('--header-height'), 10);
    if (!header || isNaN(header)) {
      header = parseInt(getComputedStyle(root).getPropertyValue('--header-height'), 10);
    }
    return header > 0 ? header : 75;
  }

  function scrollToReviewsSection() {
    var target = document.getElementById('product-reviews');
    if (!target) return false;

    var top =
      target.getBoundingClientRect().top + window.pageYOffset - getHeaderOffset();
    window.scrollTo({ top: top, behavior: 'smooth' });

    if (window.history && window.history.replaceState) {
      window.history.replaceState(
        null,
        '',
        window.location.pathname + window.location.search + '#product-reviews'
      );
    }

    return true;
  }

  function isSameProductReviewsLink(link) {
    var href = link.getAttribute('href') || '';
    if (href === '#product-reviews') return true;

    try {
      var url = new URL(link.href, window.location.origin);
      if (url.hash !== '#product-reviews') return false;

      var currentPath = window.location.pathname;
      if (url.pathname === currentPath) return true;

      var productHandle = currentPath.split('/products/')[1];
      if (productHandle && url.pathname.indexOf('/products/' + productHandle) !== -1) {
        return true;
      }
    } catch (err) {
      return false;
    }

    return false;
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a.es-judgeme-badge-link');
    if (!link || !isSameProductReviewsLink(link)) return;

    if (!scrollToReviewsSection()) return;

    event.preventDefault();
  });
})();
